import type {
  AutomationClassification,
  AutomationType,
} from '@playbook-technologies/common-enums';
import { httpClient } from '@client/new/api/api';

export type CreatorAutomationItem = {
  automationType: AutomationType;
  classification: AutomationClassification;
  enabled: boolean;
  updatedAt: string | null;
};

export const getCreatorAutomations = async (
  creatorId: number,
): Promise<CreatorAutomationItem[]> => {
  const response = await httpClient.get<CreatorAutomationItem[]>(
    '/creator/automations',
    { params: { creatorId } },
  );
  return response.data;
};

export const updateCreatorAutomation = async (
  creatorId: number,
  automationType: AutomationType,
  enabled: boolean,
): Promise<CreatorAutomationItem> => {
  const response = await httpClient.patch<CreatorAutomationItem>(
    `/creator/automations/${automationType}`,
    { enabled },
    { params: { creatorId } },
  );
  return response.data;
};
